import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'ui-mobile-navigation-skeleton',
  templateUrl: './mobile-navigation-skeleton.component.html',
  styleUrl: 'mobile-navigation-skeleton.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    NgxSkeletonLoaderModule,
  ],
})
export class MobileNavigationSkeletonComponent {
}
